<template>
  <div
    :id="`l-popper-${_uid}`"
    class="l-popper"
    @mouseover="$emit('mouseover')"
    @mouseout="$emit('mouseout')"
  >
    <div class="l-popper__inner" :style="{ 'max-height': height + 'px' }">
      <slot/>
    </div>
    <div class="l-popper__arrow" x-arrow/>
  </div>
</template>

<script>
import Popper from "popper.js";

export default {
  name: "LPopper",

  props: {
    appendTo: [String, HTMLDivElement],
    fullSize: {
      type: Boolean,
      default: false
    },
    placement: {
      type: String,
      default: "bottom-start"
    },
    popperOptions: {
      type: Object,
      default: () => {}
    },
    height: {
      type: [String, Number],
      default: 230
    }
  },

  data() {
    return {
      popper: undefined
    };
  },

  mounted() {
    document.body.appendChild(this.$el);
    this.$nextTick(() => {
      this.init();
    });
  },

  beforeDestroy() {
    this.$el.remove();
  },

  methods: {
    init() {
      const popper = this.$el;
      const options = {
        placement: this.placement,
        modifiers: {
          fullSize: {
            enabled: this.fullSize,
            order: 840,
            fn(data) {
              data.styles.minWidth = data.offsets.reference.width + "px";
              data.offsets.popper.left = data.offsets.reference.left;
              return data;
            }
          }
        }
      };
      const mergedOptions = Object.assign({}, options, this.popperOptions);
      this.popper = new Popper(this.appendTo, popper, mergedOptions);
      this.update();
    },
    update() {
      this.popper.scheduleUpdate();
    }
  }
};
</script>

<style lang="postcss">
.l-popper {
  @apply bg-white;
  @apply border border-white rounded;
  box-sizing: border-box;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  z-index: 1010;
  * {
    box-sizing: border-box;
  }
}
.l-popper__inner {
  @apply p-2 overflow-y-auto;
}
.l-popper__arrow {
  @apply absolute block;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
  border-width: 6px;
  filter: drop-shadow(0 2px 12px rgba(0, 0, 0, 0.03));
}
.l-popper__arrow::after {
  @apply absolute block;
  content: " ";
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
}
.l-popper[x-placement^="bottom"] {
}
.l-popper[x-placement^="bottom-start"] {
}
.l-popper[x-placement^="bottom-end"] {
}
.l-popper[x-placement^="top"] {
}
.l-popper[x-placement^="top-start"] {
}
.l-popper[x-placement^="top-end"] {
}
</style>
